import type { GeneratedFile } from './files';

/** What the customer's Entra ID admin types into the enterprise app's provisioning. */
export function entraFiles(tenantUrl: string, secretToken: string): GeneratedFile[] {
  return [
    {
      name: 'entra-provisioning.txt',
      content: `Microsoft Entra ID → Enterprise applications → New application → Create your own application
  (non-gallery) → Provisioning → Provisioning Mode: Automatic

Admin credentials
  Tenant URL:    ${tenantUrl}
  Secret Token:  ${secretToken}
  → Test Connection, Save

Attribute mappings (users)
  userName        ← userPrincipalName   (unique; the sign-in name)
  active          ← Switch([IsSoftDeleted], , "False", "True", "True", "False")
  externalId      ← objectId
  emails[type eq "work"].value ← mail
  name.formatted / displayName ← displayName
  name.givenName  ← givenName,  name.familyName ← surname

Groups: keep the default group mappings; each group becomes a role in NYCE.LOGIC AUTH.
Users and groups → assign who should be provisioned, then Start provisioning.
`,
      note: 'Send to the customer’s Entra admin. The secret token is shown once.',
    },
  ];
}
